import script from "./SaiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SaiPage.vue?vue&type=script&setup=true&lang=js"

import "./SaiPage.vue?vue&type=style&index=0&id=e3fb41c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3fb41c4"]])

export default __exports__